/**
 * Static fallback content for the site footer.
 * Used only when the CMS API is unavailable or returns no data.
 */
export const footerFallbackContent = {
  main: {
    description:
      "ASSET empowers individuals with practical skills, research exposure, and industry-ready training for sustainable growth.",
    addressLabel: "Communication Address:",
    address:
      "2nd Floor, Corner Woods, 24, Sanjayanagara, Bengaluru, Karnataka 560094",
    email: "care@assetsociety.ngo",
    phone: "+ 91 8879878766",
    linkedinUrl: "https://www.linkedin.com/",
    whatsappUrl: "https://wa.me/918879878766",
    gmailUrl: "https://mail.google.com/mail/?view=cm&fs=1&to=care@assetsociety.ngo",
    treeImageKey: "footer_tree",
    logoImageKey: "footer_logo",
    copyright: "Copyright © ASSET Society | All Rights Reserved",
    termsUrl: "/terms",
    privacyUrl: "/privacy",
  },
};

export default footerFallbackContent;
